<form [formGroup]="form">
  <mat-card style="margin: 0;padding: 8px">
    <mat-card-header>
      <mat-card-title>Введите код</mat-card-title>
      <mat-card-subtitle>Код отправлен на почту</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <mat-form-field>
        <mat-label>Код</mat-label>
        <input matInput formControlName="code" required>
      </mat-form-field>
    </mat-card-content>

    <mat-card-footer style="padding: 8px">
      <div class="d-flex justify-content-end m-t-8">
        <button mat-button class="m-x-8" type="button" (click)="close()" [loading]="isSubmitting">Отмена</button>
        <button mat-raised-button color="primary" (click)="save()">Подтвердить</button>
      </div>
    </mat-card-footer>
  </mat-card>
</form>

